// function setBenefitsEn(money) {
//   return `Provide each member with up to ${money} USD in annual cooperation risk protection.`
// }
// function setBenefitsCn(money) {
//   return `为每家会员提供每年最高${money}万美元的合作风险保障`
// }

export const MEMBERSHIP_BENEFITS_LIST = {
  JCE: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  JCP: [0, 1, 2, 3, 4, 5, 14, 7, 8, 9],
  JCR: [0, 1, 2, 3, 4, 5, 15, 7, 8, 9],
  JCPR: [0, 1, 2, 3, 4, 5, 15, 7, 8, 9],
  JCDG: [0, 1, 2, 3, 4, 5, 15, 7, 8, 9],
  JCEC: [0, 1, 2, 3, 4, 5, 15, 7, 8, 9],
  JCRA: [0, 1, 2, 3, 4, 5, 15, 7, 8, 9],
  JCV: [1, 12, 13, 4, 5, 2],
}

export const OVERVIEW_LIST = [
  {
    cn: '查看公司名录',
    en: 'Company Directory',
    isNew: false, // 新的
    isCommon: true, // 共用的
  },
  {
    cn: '查看黑名单',
    en: 'View Blacklist',
    isNew: false, // 新的
    isCommon: true, // 共用的
  },
  {
    cn: '享有船期查询、货物跟踪查询、HScode查询',
    en: 'Shipping schedule query, cargo tracking, HScode query',
    isNew: true, // 新的
    isCommon: true, // 共用的
  },
  {
    cn: '合作风险保障',
    en: 'Cooperation Risk Protection',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '即时通讯',
    en: 'Instant Messaging',
    isNew: true, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '查看全球货运代理联系信息',
    en: 'Access to Global Freight Forwarders Contact Information',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '公司排名优先',
    en: 'Priority Ranking',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '社交媒体推广',
    en: 'Social Media Marketing',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '电子邮件推广',
    en: 'Email Marketing',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '1对1客户服务',
    en: '1 on 1 Customer Success Support',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '全天候业务撮合',
    en: '24/7 Business Assistance',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '会员专属标识',
    en: 'Membership Symbol',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: 'JCtrans全球交易洽谈会折扣',
    en: 'JCtrans Global Freight Forwarders Conference Discount',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: 'JCtrans展会折扣',
    en: 'JCtrans Expo Discount',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '跨境交易服务',
    en: 'Cross-Boarder Transaction Services',
    isNew: false, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '享有FMC、无船承运人资质办理的优惠价格',
    en: 'FMC, NVOCC Qualification Discount',
    isNew: true, // 新的
    isCommon: false, // 共用的
  },
  {
    cn: '反恐舱单及国内预配舱单申报优惠',
    en: 'Customs Filing and Pre-manifest Filing Discount',
    isNew: true, // 新的
    isCommon: false, // 共用的
  },
]
export const BASE_BENEFITS_LIST_EN_NEW = {
  JCE: [
    {
      title: 'Business Opportunity Matching',
      children: [
        {
          subTitle: 'Company Directory',
          children: [
            'Join the JCtrans Global Freight Forwarding Platform and access our company directory with over 12,000 freight forwarding members across 181 countries.',
            'As an Elite member, your company will receive priority display in the company directory.',
          ],
        },
        {
          subTitle: 'Shop',
          children: [
            'Activate your exclusive online storefront to showcase corporate videos, promotional images, case studies, and company profiles.',
            'Enjoy an exclusive premium visual theme for your JC Elite membership store.',
          ],
        },
        {
          subTitle: 'Inquiry Board',
          children: [
            'Receive inquiries from global peers via the inquiry board and make a quote online. You can also post inquiry to receive agent quotes globally.',
            'Elite members are prioritized for accurate matching with high-quality exclusive inquiries and enjoy preferential quoting rights.',
            'Elite members unlock inquiry privilege-submit offers to inquiry board posts even when closed within 7 days, and directly access offeror contacts.',
          ],
        },
        {
          subTitle: 'Customer Success',
          children: [
            'Enjoy 1 on 1 customer success support by a senior customer success manager.',
          ],
        },
      ],
    },
    {
      title: 'Cooperation Risk Protection',
      children: [
        {
          subTitle: 'Protection',
          children: [
            'For inter-member cooperation, enjoy up to $150,000 in cooperation risk protection.',
          ],
        },
        {
          subTitle: 'Online Claim',
          children: [
            'Use the fast track claim channel for dispute resolution, with guaranteed settlement and compensation upon acceptance within 60 days.',
          ],
        },
        {
          subTitle: 'Risk Data',
          children: [
            'Access the platform’s blacklist to view historical records of bad debts or disputes involving other members.',
            'Risk Alerts subscription allows tracking risk data for up to 150 companies, with real-time notifications.',
          ],
        },
        {
          subTitle: 'Expert Service',
          children: [
            'Receive 1 on 1 consultation with a Risk Management Expert via phone for personalized support.',
          ],
        },
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        {
          subTitle: 'Member Identity',
          children: [
            'Display your exclusive JC Elite member identity across your store and company directory.',
          ],
        },
        {
          subTitle: 'Promotion',
          children: [
            "We will provide JCtrans' global 12,000+ members and 640,000+ social media/private community followers with exclusive email promotion and social media promotion.",
          ],
        },
        // {
        //   subTitle: 'Global Conference',
        //   children: [
        //     'JCtrans Global Freight Forwarders Conference features an exclusive award ceremony for JCtrans Elite members.',
        //   ],
        // },
        {
          subTitle: 'Video Promotion',
          children: [
            'Priority access to onsite video interviews at conferences, later promoted as success story or leading voice on social media.',
          ],
        },
        {
          subTitle: 'Online Meeting',
          children: [
            'Priority access & exclusive sharing privileges for JCtrans Connect⁺ online meeting.',
          ],
        },
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        {
          subTitle: 'Payment',
          children: [
            'Access JC Pay services for global settlements and cross-border payment (T.C.S); enjoy fee-free, fast, and compliant transactions among members.',
          ],
        },
        {
          subTitle: 'Tools',
          children: [
            'Shipping Schedule 2000/month, Container Tracking 200/month.',
          ],
        },
        {
          subTitle: 'Discounts',
          children: [
            'Enjoy member discounts starting from $100 on JCtrans Events, as well as special rates for freight insurance and HBL customs filing.',
          ],
        },
        {
          subTitle: 'Sub-Accounts',
          children: [
            'Multi-user support with 15 sub-accounts included in the membership package.',
          ],
        },
      ],
    },
  ],
  JCP: [
    {
      title: 'Business Opportunity Matching',
      children: [
        {
          subTitle: 'Company Directory',
          children: [
            'Join the JCtrans Global Freight Forwarding Platform and access our company directory with over 12,000 freight forwarding members across 181 countries.',
            'Your company will receive priority display in the Company Directory.',
          ],
        },
        {
          subTitle: 'Shop',
          children: [
            'Activate your exclusive online storefront to showcase corporate videos, promotional images, case studies, and company profiles.',
          ],
        },
        {
          subTitle: 'Inquiry Board',
          children: [
            'Receive inquiries from global peers via the Inquiry Board and Make a Quote online. You can also Post Inquiry to receive agent quotes globally.',
          ],
        },
        {
          subTitle: 'Customer Success',
          children: ['Enjoy 1-on-1 Customer Success Support.'],
        },
      ],
    },
    {
      title: 'Cooperation Risk Protection',
      children: [
        {
          subTitle: 'Protection',
          children: [
            'For inter-member cooperation, enjoy up to $100,000 in Cooperation Risk Protection.',
          ],
        },
        {
          subTitle: 'Risk Data',
          children: [
            'Access the platform’s blacklist to view historical records of bad debts or disputes involving other members.',
            'Risk Alerts subscription allows tracking risk data for up to 100 companies, with real-time notifications.',
          ],
        },
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        {
          subTitle: 'Member Identity',
          children: [
            'Display your Exclusive JC Premium Member Identity across your store and Company Directory.',
          ],
        },
        {
          subTitle: 'Promotion',
          children: [
            "We will provide JCtrans' global 12,000+ members and 640,000+ social media/private community followers with Email Promotion and Social Media Promotion.",
          ],
        },
        {
          subTitle: 'Online Meeting',
          children: ['Access JCtrans Connect⁺ Online Meeting.'],
        },
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        {
          subTitle: 'Payment',
          children: [
            'Access JC Pay services for global settlements and cross-border payment (T.C.S); enjoy fee-free, fast, and compliant transactions among members.',
          ],
        },
        {
          subTitle: 'Tools',
          children: [
            'Shipping Schedule 1000/month, Container Tracking 100/month.',
          ],
        },
        {
          subTitle: 'Discounts',
          children: [
            'Enjoy member discounts starting from $100 on JCtrans Events, as well as special rates for freight insurance and HBL customs filing.',
          ],
        },
        {
          subTitle: 'Sub-Accounts',
          children: [
            'Multi-user support with 10 Sub-Accounts included in the membership package.',
          ],
        },
      ],
    },
  ],
  JCR: [
    {
      title: 'Business Opportunity Matching',
      children: [
        {
          subTitle: 'Company Directory',
          children: [
            'Join the JCtrans Global Freight Forwarding Platform and access our company directory with over 12,000 freight forwarding members across 181 countries.',
            'Your company will receive priority display in the Company Directory.',
          ],
        },
        {
          subTitle: 'Shop',
          children: [
            'Activate your exclusive online storefront to showcase corporate videos, promotional images, case studies, and company profiles.',
          ],
        },
        {
          subTitle: 'Inquiry Board',
          children: [
            'Receive inquiries from global peers via the Inquiry Board and make a quote online. You can also post an inquiry to receive agent quotes globally.',
          ],
        },
        {
          subTitle: 'Customer Success',
          children: ['Enjoy 1-on-1 Customer Success Support.'],
        },
      ],
    },
    {
      title: 'Cooperation Risk Protection',
      children: [
        {
          subTitle: 'Protection',
          children: [
            'For inter-member cooperation, enjoy up to $100,000 in Cooperation Risk Protection.',
          ],
        },
        {
          subTitle: 'Risk Data',
          children: [
            'Access the platform’s blacklist to view historical records of bad debts or disputes involving other members.',
            'Risk Alerts subscription allows tracking risk data for up to 100 companies, with real-time notifications.',
          ],
        },
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        {
          subTitle: 'Member Identity',
          children: [
            'Display your Exclusive JC Rising Member Identity across your store and Company Directory.',
          ],
        },
        {
          subTitle: 'Promotion',
          children: [
            "We will provide JCtrans' global 12,000+ members and 640,000+ social media/private community followers with Email Promotion and Social Media Promotion.",
          ],
        },
        {
          subTitle: 'Online Meeting',
          children: ['Access JCtrans Connect⁺ Online Meeting.'],
        },
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        {
          subTitle: 'Payment',
          children: [
            'Access JC Pay services for global settlements and cross-border payment (T.C.S); enjoy fee-free, fast, and compliant transactions among members.',
          ],
        },
        {
          subTitle: 'Tools',
          children: [
            'Shipping Schedule 500/month, Container Tracking 100/month.',
          ],
        },
        {
          subTitle: 'Discounts',
          children: [
            'Enjoy member discounts starting from $100 on JCtrans Events, as well as special rates for freight insurance and HBL customs filing.',
          ],
        },
        {
          subTitle: 'Sub-Accounts',
          children: [
            'Multi-user support with 10 Sub-Accounts included in the membership package.',
          ],
        },
      ],
    },
  ],
  JC_SPECIAL: [
    {
      title: 'Business Opportunity Matching',
      children: [
        {
          subTitle: 'Company Directory',
          children: [
            'Join the JCtrans Global Freight Forwarding Platform and access our company directory with over 12,000 freight forwarding members across 181 countries.',
            'Your company will receive priority display in the Company Directory.',
          ],
        },
        {
          subTitle: 'Shop',
          children: [
            'Activate your exclusive online storefront to showcase corporate videos, promotional images, case studies, and company profiles.',
          ],
        },
        {
          subTitle: 'Inquiry Board',
          children: [
            'Receive inquiries from global peers via the inquiry board and make a quote online. You can also post inquiry to receive agent quotes globally.',
          ],
        },
        {
          subTitle: 'Customer Success',
          children: ['Enjoy 1-on-1 Customer Success Support.'],
        },
      ],
    },
    {
      title: 'Cooperation Risk Protection',
      children: [
        {
          subTitle: 'Protection',
          children: [
            'For inter-member cooperation, enjoy up to $50,000 in Cooperation Risk Protection.',
          ],
        },
        {
          subTitle: 'Risk Data',
          children: [
            'Access the platform’s blacklist to view historical records of bad debts or disputes involving other members.',
            'Risk Alerts subscription allows tracking risk data for up to 100 companies, with real-time notifications.',
          ],
        },
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        {
          subTitle: 'Member Identity',
          children: [
            'Display your Exclusive {name} Member Identity across your store and Company Directory.',
          ],
        },
        {
          subTitle: 'Promotion',
          children: [
            "We will provide JCtrans' global 12,000+ members and 640,000+ social media/private community followers with Email Promotion and Social Media Promotion.",
          ],
        },
        {
          subTitle: 'Online Meeting',
          children: ['Access JCtrans Connect⁺ Online Meeting.'],
        },
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        {
          subTitle: 'Payment',
          children: [
            'Access JC Pay services for global settlements and cross-border payment (T.C.S); enjoy fee-free, fast, and compliant transactions among members.',
          ],
        },
        {
          subTitle: 'Tools',
          children: [
            'Shipping Schedule 500/month, Container Tracking 100/month.',
          ],
        },
        {
          subTitle: 'Discounts',
          children: [
            'Enjoy member discounts starting from $100 on JCtrans Events, as well as special rates for freight insurance and HBL customs filing.',
          ],
        },
        {
          subTitle: 'Sub-Accounts',
          children: [
            'Multi-user support with 10 Sub-Accounts included in the membership package.',
          ],
        },
      ],
    },
  ],
  JCV: [
    {
      title: 'Business Opportunity Matching',
      children: [
        {
          subTitle: 'Company Directory',
          children: [
            'Join the JCtrans Global Freight Forwarding Platform and access our company directory with over 12,000 freight forwarding members across 181 countries.',
            'Your company will receive priority display in the Company Directory.',
          ],
        },
        {
          subTitle: 'Shop',
          children: [
            'Activate your exclusive online storefront to showcase corporate videos, promotional images, case studies, and company profiles.',
          ],
        },
        {
          subTitle: 'Inquiry Board',
          children: [
            'Receive inquiries from global peers via the inquiry board and make a quote online. You can also post inquiry to receive agent quotes globally.',
          ],
        },
        {
          subTitle: 'Customer Success',
          children: ['Enjoy 1-on-1 Customer Success Support.'],
        },
      ],
    },
    {
      title: 'Cooperation Risk Protection',
      children: [
        {
          subTitle: 'Risk Data',
          children: [
            'Access the platform’s blacklist to view historical records of bad debts or disputes involving other members.',
          ],
        },
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        {
          subTitle: 'Member Identity',
          children: [
            'Display your Exclusive JC Vendor Member Identity across your store and Company Directory.',
          ],
        },
        {
          subTitle: 'Promotion',
          children: [
            "We will provide JCtrans' global 12,000+ members and 640,000+ social media/private community followers with Exclusive Email Promotion and Exclusive Social Media Promotion once per month.",
          ],
        },
        {
          subTitle: 'Online Meeting',
          children: ['Access JCtrans Connect⁺ Online Meeting.'],
        },
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        {
          subTitle: 'Payment',
          children: [
            'Access JC Pay services for global settlements and cross-border payment (T.C.S); enjoy fee-free, fast, and compliant transactions among members.',
          ],
        },
        {
          subTitle: 'Discounts',
          children: [
            'Enjoy member discounts starting from $100 on JCtrans Events, as well as special rates for freight insurance and HBL customs filing.',
          ],
        },
        {
          subTitle: 'Sub-Accounts',
          children: [
            'Multi-user support with 10 Sub-Accounts included in the membership package.',
          ],
        },
      ],
    },
  ],
}

const BASE_BENEFITS_LIST_EN = {
  JCE: [
    {
      title: 'Cooperation Risk Protection',
      children: [
        'Enjoy the highest risk protection amount of $150,000 and access to an exclusive rapid dispute resolution channel.',
        'Cross-alliance cooperation guarantees range from $50,000 to $100,000.',
      ],
    },
    {
      title: 'Business Opportunity Matching',
      children: [
        'Highest priority in obtaining Forwarder Helper Platform inquiry matches, with dedicated senior account managers providing one-on-one support to recommend potential cooperation opportunities.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Exclusive high-end JCE member identity marker.',
        'Company profile prioritized above all other member identities.',
        'Over ten thousand reliable member resources from 168 countries available for selection.',
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        'Exclusive JCtrans promotion, maximizing company brand and service publicity.',
        'Continuous push to 30,000+ fans and 10,000+ paid members, effectively enhancing corporate brand recognition.',
        'Exclusive email promotion.',
        'Exclusive social media promotion.',
        'One dedicated company promotion.',
        'Premium interview display on the main site.',
        'Customized brochure distribution at meetings.',
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        '15 sub-accounts can simultaneously log in to use online tools for full cargo tracking, vessel schedule inquiry, HS Code search, etc., and enjoy preferential rates for bill of lading reporting and FMC applications.',
        'Instant messaging (IM) for online contacts on the main site platform.',
        'Use of online payment tools like JCPAY and TCS.',
        'Unlimited vessel schedule, full cargo tracking, and HS Code search services.',
        'Preferential rates for bill of lading reporting (AMS/ISF/ACI(EM)/AFR).',
        'Discounted rates for FMC applications.',
      ],
    },
  ],
  JCP: [
    {
      title: 'Cooperation Risk Protection',
      children: [
        'Enjoy a cooperation risk protection amount of $100,000.',
        'Professional team assistance for dispute resolution.',
        'Cross-alliance cooperation guarantee ranges from $25,000 to $50,000.',
      ],
    },
    {
      title: 'Business Opportunity Matching',
      children: [
        'Dedicated account managers provide one-on-one assistance to recommend potential partners and business opportunities.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Exclusive high-end JCP member identity marker.',
        'Over ten thousand reliable member resources from 168 countries available for selection.',
        'Unlimited posting and responding to inquiries on the Forwarder Helper Platform.',
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        'Regular JC promotional services.',
        'Continuous push to 30,000+ fans and 10,000+ paid members, effectively enhancing corporate brand recognition.',
        'Email Marketing Promotion.',
        'Social media promotion.',
        'Premium interview display on the main site.',
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        '9 sub-accounts can simultaneously log in to use online tools for full cargo tracking, vessel schedule inquiry, HS Code search, etc., and enjoy preferential rates for bill of lading reporting and FMC applications.',
        'Instant messaging (IM) for online contacts on the main site platform.',
        'Use of online payment tools like JCPAY and TCS.',
        'Unlimited vessel schedule, full cargo tracking, and HS Code search services.',
        'Preferential rates for bill of lading reporting (AMS/ISF/ACI(EM)/AFR).',
        'Discounted rates for FMC applications.',
      ],
    },
  ],
  JCR: [
    {
      title: 'Cooperation Risk Protection',
      children: [
        'Enjoy a cooperation risk protection amount of $50,000.',
        'Professional team assistance for dispute resolution.',
        'Cross-alliance cooperation guarantee of $25,000.',
      ],
    },
    {
      title: 'Business Opportunity Matching',
      children: [
        'Obtain JCR member certification and expand business with thousands of potential global partners.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Dedicated account managers provide one-on-one assistance to recommend potential partners and business opportunities.',
        'Exclusive high-end JCR member identity marker.',
        'Unlimited posting and responding to inquiries on the Forwarder Helper Platform.',
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        'Regular JC promotional services.',
        'Continuous push to 30,000+ fans and 10,000+ paid members, effectively enhancing corporate brand recognition.',
        'Email Marketing Promotion.',
        'Social media promotion.',
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        'Online tools for full cargo tracking, vessel schedule, and HS Code inquiry, with preferential rates for bill of lading reporting and FMC applications.',
        'Instant messaging (IM) for online contacts on the main site platform.',
        'Use of online payment tools like JCPAY and TCS.',
        'Unlimited vessel schedule, full cargo tracking, and HS Code search services.',
        'Preferential rates for bill of lading reporting (AMS/ISF/ACI(EM)/AFR).',
        'Discounted rates for FMC applications.',
      ],
    },
  ],
  SPECIAL: [
    {
      title: 'Cooperation Risk Protection',
      children: [
        'Enjoy specialized cooperation risk protection amount of $50,000.',
        'Professional team assistance for dispute resolution.',
        'Cross-alliance cooperation guarantee of $25,000.',
      ],
    },
    {
      title: 'Business Opportunity Matching',
      children: [
        'Targeted inquiry matching and potential business matchmaking for specialized cargo.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Exclusive member identity marker.',
        'Dedicated account managers provide one-on-one assistance to recommend potential partners and business opportunities.',
        'Over ten thousand reliable member resources from 168 countries available for selection.',
        'Unlimited posting and responding to inquiries on the Forwarder Helper Platform.',
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        'Online promotion of successful case studies for specialized cargo.',
        'Continuous push to 30,000+ fans and 10,000+ paid members, effectively enhancing corporate brand recognition.',
        'Special section on the main site platform showcasing cargo operation case studies.',
        'Email Marketing Promotion.',
        'Social media promotion.',
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        'Online tools for full cargo tracking, vessel schedule, and HS Code inquiry, with preferential rates for bill of lading reporting and FMC applications.',
        'Instant messaging (IM) for online contacts on the main site platform.',
        'Use of online payment tools like JCPAY and TCS.',
        'Unlimited vessel schedule, full cargo tracking, and HS Code search services.',
        'Preferential rates for bill of lading reporting (AMS/ISF/ACI(EM)/AFR).',
        'Discounted rates for FMC applications.',
      ],
    },
  ],
  JCV: [
    {
      title: 'Rich Global Freight Forwarder Resources',
      children: [
        'Exclusive JCV member identifier display in the company directory.',
      ],
    },
    {
      title: 'Business Opportunity Matching',
      children: [
        'Forwarder Helper Platform + dedicated account manager one-on-one support.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Over ten thousand reliable member resources from 168 countries available for selection.',
        'Unlimited posting and responding to inquiries on the Forwarder Helper Platform.',
        'Dedicated account managers provide one-on-one assistance to recommend potential partners and business opportunities.',
      ],
    },
    {
      title: 'Marketing and Promotion Services',
      children: [
        'One exclusive email promotion per month.',
        'The inquiry system pushes an average of over 10,000 business opportunities per month, with the fastest response time of 3 minutes linking to over 10,000 quality freight forwarders.',
        'Social media promotion.',
        'Premium interview display on the main site.',
        'Customized brochures distributed at each meeting.',
      ],
    },
    {
      title: 'Reduce Costs and Boost Efficiency',
      children: [
        'Real-time online communication with global freight forwarder members.',
        'Instant messaging (IM) for online contacts on the main site platform.',
        'Use of online payment tools like JCPAY and TCS.',
        'Member-to-member cooperation benefits and privileges.',
      ],
    },
  ],
}

export const BASE_BENEFITS_LIST_CN_NEW = {
  JCE: [
    {
      title: '商机链接',
      children: [
        {
          subTitle: '名录',
          children: [
            `全球代理名录库查看权，可通过JCtrans网站名录搜索到超过12,000家活跃会员，遍布181个国家。`,
            `作为高端精英会员，您的企业会优先展示在我们的会员名录列表。`,
          ],
        },
        {
          subTitle: '店铺',
          children: [
            `可开通专属在线店铺，展示您的企业视频、宣传图片、合作案例、公司简介等。`,
            `可享受专属高端JCE会员店铺背景样式。`,
          ],
        },
        {
          subTitle: '询盘',
          children: [
            `可通过网站询盘系统获得全球同行询盘，您可在线报价洽谈商机。可也通过询盘系统发布询盘，获取全球代理报价。`,
            `可优先匹配到平台最优质的“详细询盘”，优先获得报价机会。`,
            `享受询盘加塞报价特权，对于已应满或结束7天内的询盘别人无法报价，您都可以特权进行报价，获取发盘人联系方式。`,
          ],
        },
        {
          subTitle: '客成服务',
          children: [`享受高级客户成功经理1V1服务。`],
        },
      ],
    },
    {
      title: '风险保障',
      children: [
        {
          subTitle: '保障',
          children: [`会员间合作，最高享受合作风险保障$150000。`],
        },
        {
          subTitle: '申诉',
          children: [
            `发生纠纷时，可通过专属快速纠纷处理通道，受理后60天内结案赔付。`,
          ],
        },
        {
          subTitle: '风控数据',
          children: [
            `查看平台黑名单及其他会员产生坏账、纠纷的历史记录。`,
            `可订阅150家企业风险数据，第一时间接受风险推送。`,
          ],
        },
        {
          subTitle: '专家服务',
          children: [`享高级风控专家1V1服务，电话沟通解答。`],
        },
      ],
    },
    {
      title: '品牌推广',
      children: [
        {
          subTitle: '身份标识',
          children: [
            `在平台网站名录、店铺中展示专属高端JC Elite会员身份标识。`,
          ],
        },
        {
          subTitle: '推广服务',
          children: [
            `我们将向JCtrans全球12000+会员，和64万+社媒和私域群粉丝提供专属独家邮件推广和社媒推广。`,
          ],
        },
        // {
        //   subTitle: '会议颁奖',
        //   children: [`享受JCtrans主办的全球交易洽谈会中JC Elite专属颁奖环节。`],
        // },
        {
          subTitle: '视频宣传',
          children: [`可优先报名参与会员成功案例或高端访谈视频采访。`],
        },
        {
          subTitle: '线上会议',
          children: [`JCtrans Connect⁺线上会议，享受优先参与权和优先分享。`],
        },
      ],
    },
    {
      title: '经营提效',
      children: [
        {
          subTitle: '支付',
          children: [
            `享有JC Pay支付平台服务，包括全球会员间结算工具（会员间零费用快速完成转账）和跨境支付服务。`,
          ],
        },
        {
          subTitle: '工具',
          children: [`船期查询2000次/月，全链路查询200次/月。`],
        },
        {
          subTitle: '优惠',
          children: [
            `会员享受全球会议专属门票优惠$100美金起，平台的保险、舱单等服务也有会员优惠活动。`,
          ],
        },
        {
          subTitle: '账号',
          children: [`享有15个会员权限账号，支持多人使用。`],
        },
      ],
    },
  ],
  JCP: [
    {
      title: '商机链接',
      children: [
        {
          subTitle: '名录',
          children: [
            '全球代理名录库查看权，可通过JCtrans网站名录搜索到超过12,000家活跃会员，遍布181个国家。',
            '您的企业会优先展示在我们的会员名录列表。',
          ],
        },
        {
          subTitle: '店铺',
          children: [
            '可开通专属在线店铺，展示您的企业视频、宣传图片、合作案例、公司简介等。',
          ],
        },
        {
          subTitle: '询盘',
          children: [
            '可通过网站询盘系统获得全球同行询盘，您可在线报价洽谈商机。可也通过询盘系统发布询盘，获取全球代理报价。',
          ],
        },
        {
          subTitle: '客成服务',
          children: ['享受客户成功经理1V1服务。'],
        },
      ],
    },
    {
      title: '风险保障',
      children: [
        {
          subTitle: '保障',
          children: ['会员间合作，最高享受合作风险保障$100000。'],
        },
        {
          subTitle: '风控数据',
          children: [
            '查看平台黑名单及其他会员产生坏账、纠纷的历史记录。',
            '可订阅100家企业风险数据，第一时间接受风险推送。',
          ],
        },
      ],
    },
    {
      title: '品牌推广',
      children: [
        {
          subTitle: '身份标识',
          children: ['在平台网站名录、店铺中展示专属JC Premium会员身份标识。'],
        },
        {
          subTitle: '推广服务',
          children: [
            '我们将向JCtrans全球12000+会员，和64万+社媒和私域群粉丝提供邮件推广和社媒推广。',
          ],
        },
        {
          subTitle: '线上会议',
          children: ['可以参加JCtrans Connect⁺线上会议。'],
        },
      ],
    },
    {
      title: '经营提效',
      children: [
        {
          subTitle: '支付',
          children: [
            '享有JC Pay支付平台服务，包括全球会员间结算工具（会员间零费用快速完成转账）和跨境支付服务。',
          ],
        },
        {
          subTitle: '工具',
          children: ['船期查询1000次/月，全链路查询100次/月。'],
        },
        {
          subTitle: '优惠',
          children: [
            '会员享受全球会议专属门票优惠$100美金起，平台的保险、舱单等服务也有会员优惠活动。',
          ],
        },
        {
          subTitle: '账号',
          children: ['享有10个会员权限账号，支持多人使用。'],
        },
      ],
    },
  ],
  JCR: [
    {
      title: '商机链接',
      children: [
        {
          subTitle: '名录',
          children: [
            '全球代理名录库查看权，可通过JCtrans网站名录搜索到超过12,000家活跃会员，遍布181个国家。',
            '您的企业会优先展示在我们的会员名录列表。',
          ],
        },
        {
          subTitle: '店铺',
          children: [
            '可开通专属在线店铺，展示您的企业视频、宣传图片、合作案例、公司简介等。',
          ],
        },
        {
          subTitle: '询盘',
          children: [
            '可通过网站询盘系统获得全球同行询盘，您可在线报价洽谈商机。可也通过询盘系统发布询盘，获取全球代理报价。',
          ],
        },
        {
          subTitle: '客成服务',
          children: ['享受客户成功经理1V1服务。'],
        },
      ],
    },
    {
      title: '风险保障',
      children: [
        {
          subTitle: '保障',
          children: ['会员间合作，最高享受合作风险保障$100000。'],
        },
        {
          subTitle: '风控数据',
          children: [
            '查看平台黑名单及其他会员产生坏账、纠纷的历史记录。',
            '可订阅100家企业风险数据，第一时间接受风险推送。',
          ],
        },
      ],
    },
    {
      title: '品牌推广',
      children: [
        {
          subTitle: '身份标识',
          children: ['在平台网站名录、店铺中展示专属JC Rising会员身份标识。'],
        },
        {
          subTitle: '推广服务',
          children: [
            '我们将向JCtrans全球12000+会员，和64万+社媒和私域群粉丝提供邮件推广和社媒推广。',
          ],
        },
        {
          subTitle: '线上会议',
          children: ['可以参加JCtrans Connect⁺线上会议。'],
        },
      ],
    },
    {
      title: '经营提效',
      children: [
        {
          subTitle: '支付',
          children: [
            '享有JC Pay支付平台服务，包括全球会员间结算工具（会员间零费用快速完成转账）和跨境支付服务。',
          ],
        },
        {
          subTitle: '工具',
          children: ['船期查询500次/月，全链路查询100次/月。'],
        },
        {
          subTitle: '优惠',
          children: [
            '会员享受全球会议专属门票优惠$100美金起，平台的保险、舱单等服务也有会员优惠活动。',
          ],
        },
        {
          subTitle: '账号',
          children: ['享有10个会员权限账号，支持多人使用。'],
        },
      ],
    },
  ],
  JC_SPECIAL: [
    {
      title: '商机链接',
      children: [
        {
          subTitle: '名录',
          children: [
            '全球代理名录库查看权，可通过JCtrans网站名录搜索到超过12,000家活跃会员，遍布181个国家。',
            '您的企业会优先展示在我们的会员名录列表。',
          ],
        },
        {
          subTitle: '店铺',
          children: [
            '可开通专属在线店铺，展示您的企业视频、宣传图片、合作案例、公司简介等。',
          ],
        },
        {
          subTitle: '询盘',
          children: [
            '可通过网站询盘系统获得全球同行询盘，您可在线报价洽谈商机。可也通过询盘系统发布询盘，获取全球代理报价。',
          ],
        },
        {
          subTitle: '客成服务',
          children: ['享受客户成功经理1V1服务。'],
        },
      ],
    },
    {
      title: '风险保障',
      children: [
        {
          subTitle: '保障',
          children: ['会员间合作，最高享受合作风险保障$50000。'],
        },
        {
          subTitle: '风控数据',
          children: [
            '查看平台黑名单及其他会员产生坏账、纠纷的历史记录。',
            '可订阅100家企业风险数据，第一时间接受风险推送。',
          ],
        },
      ],
    },
    {
      title: '品牌推广',
      children: [
        {
          subTitle: '身份标识',
          children: ['在平台网站名录、店铺中展示专属{name}会员身份标识。'],
        },
        {
          subTitle: '推广服务',
          children: [
            '我们将向JCtrans全球12000+会员，和64万+社媒和私域群粉丝提供邮件推广和社媒推广。',
          ],
        },
        {
          subTitle: '线上会议',
          children: ['可以参加JCtrans Connect⁺线上会议。'],
        },
      ],
    },
    {
      title: '经营提效',
      children: [
        {
          subTitle: '支付',
          children: [
            '享有JC Pay支付平台服务，包括全球会员间结算工具（会员间零费用快速完成转账）和跨境支付服务。',
          ],
        },
        {
          subTitle: '工具',
          children: ['船期查询500次/月，全链路查询100次/月。'],
        },
        {
          subTitle: '优惠',
          children: [
            '会员享受全球会议专属门票优惠$100美金起，平台的保险、舱单等服务也有会员优惠活动。',
          ],
        },
        {
          subTitle: '账号',
          children: ['享有10个会员权限账号，支持多人使用。'],
        },
      ],
    },
  ],
  JCV: [
    {
      title: '商机链接',
      children: [
        {
          subTitle: '名录',
          children: [
            '全球代理名录库查看权，可通过JCtrans网站名录搜索到超过12,000家活跃会员，遍布181个国家。',
            '您的企业会优先展示在我们的会员名录列表。',
          ],
        },
        {
          subTitle: '店铺',
          children: [
            '可开通专属在线店铺，展示您的企业视频、宣传图片、合作案例、公司简介等。',
          ],
        },
        {
          subTitle: '询盘',
          children: [
            '可通过网站询盘系统获得全球同行询盘，您可在线报价洽谈商机。可也通过询盘系统发布询盘，获取全球代理报价。',
          ],
        },
        {
          subTitle: '客成服务',
          children: ['享受客户成功经理1V1服务。'],
        },
      ],
    },
    {
      title: '风险保障',
      children: [
        {
          subTitle: '风控数据',
          children: ['查看平台黑名单及其他会员产生坏账、纠纷的历史记录。'],
        },
      ],
    },
    {
      title: '品牌推广',
      children: [
        {
          subTitle: '身份标识',
          children: ['在平台网站名录、店铺中展示专属JC Vendor会员身份标识。'],
        },
        {
          subTitle: '推广服务',
          children: [
            '我们将向JCtrans全球12,000+会员，和64万+社媒和私域群粉丝提供每月一次的独家邮件推广和独家社媒推广。',
          ],
        },
        {
          subTitle: '线上会议',
          children: ['可以参加JCtrans Connect⁺线上会议。'],
        },
      ],
    },
    {
      title: '经营提效',
      children: [
        {
          subTitle: '支付',
          children: [
            '享有JC Pay支付平台服务，包括全球会员间结算工具（会员间零费用快速完成转账）和跨境支付服务。',
          ],
        },
        {
          subTitle: '优惠',
          children: [
            '会员享受全球会议专属门票优惠$100美金起，平台的保险、舱单等服务也有会员优惠活动。',
          ],
        },
        {
          subTitle: '账号',
          children: ['享有10个会员权限账号，支持多人使用。'],
        },
      ],
    },
  ],
}

const BASE_BENEFITS_LIST_CN = {
  JCE: [
    {
      title: '合作风险保障',
      children: [
        '享受最高风险保障金额15万美金，且享受专属快速纠纷处理通道',
        '跨联盟合作担保享受5-10万美金',
      ],
    },
    {
      title: '商机链接',
      children: [
        '最高优先权获得询盘匹配，专属高级客成经理一对一支持推荐潜在合作机会',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '专属高端JCE会员身份标识',
        '公司库优于所有会员身份展示',
        '共计一万多家来自168个国家靠谱会员资源可供选择',
      ],
    },
    {
      title: '营销推广',
      children: [
        'JC专属独家推广，最大限度宣传公司品牌和服务',
        '向13万+粉丝、1万+付费会员持续推送，有效提升企业品牌知名度',
        '独家邮件推广',
        '独家社交媒体推广',
        '公司专属推广一次',
        '主站高端访谈展示',
        '定制化宣传手册会议发放',
      ],
    },
    {
      title: '经营提效',
      children: [
        '15个子账号可同时登录使用在线工具-全链路追踪，船期查询，HS Code查询等，并享受舱单申报和FMC申请优惠',
        '主站平台IM即时沟通在线联系',
        '线上支付工具使用JCPAY和TCS',
        '无上限船期、全链路跟踪、HScode查询服务',
        '舱单申报优惠 AMS/ISF/ACI(EM)/AFR',
        '优惠价格享受FMC申请',
      ],
    },
  ],
  JCP: [
    {
      title: '合作风险保障',
      children: [
        '享受合作风险保障金额10万美金',
        '专业团队协助纠纷处理',
        '跨联盟合作担保享受2.5万-5万美金',
      ],
    },
    {
      title: '商机链接',
      children: [
        '专属客成经理一对一协助推荐潜在合作伙伴和生意',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '专属高端JCP会员身份标识',
        '上万家来自168个国家靠谱会员资源可供选择',
        '询盘平台无限发盘/应盘',
      ],
    },
    {
      title: '营销推广',
      children: [
        'JC定期推广服务',
        '向3万+粉丝、1万+付费会员持续推送，有效提升企业品牌知名度',
        '邮件推广',
        '社交媒体推广',
        '主站高端访谈展示',
      ],
    },
    {
      title: '经营提效',
      children: [
        '9个子账号可同时登录使用在线工具-全链路追踪，船期查询，HS Code查询等，并享受舱单申报和FMC申请优惠',
        '主站平台IM即时沟通在线联系',
        '线上支付工具使用JCPAY和TCS',
        '无上限船期、全链路跟踪、HScode查询服务',
        '舱单申报优惠 AMS/ISF/ACI(EM)/AFR',
        '优惠价格享受FMC申请',
      ],
    },
  ],
  JCR: [
    {
      title: '合作风险保障',
      children: [
        '享受合作风险保障金额5万美金',
        '专业团队协助纠纷处理',
        '跨联盟合作担保享受2.5万美金',
      ],
    },
    {
      title: '商机链接',
      children: [
        '获得JCR会员资质认证，全球上万家潜在合作伙伴拓展生意',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '专属客成经理一对一协助推荐潜在合作伙伴和生意',
        '专属高端JCR会员身份标识',
        '询盘平台无限发盘/应盘',
      ],
    },
    {
      title: '营销推广',
      children: [
        'JC定期推广服务',
        '向3万+粉丝、1万+付费会员持续推送，有效提升企业品牌知名度',
        '邮件推广',
        '社交媒体推广',
      ],
    },
    {
      title: '经营提效',
      children: [
        '在线使用全链路追踪，船期和HS Code查询功能，享受舱单申报和FMC申请优惠',
        '主站平台IM即时沟通在线联系',
        '线上支付工具使用JCPAY和TCS',
        '无上限船期、全链路跟踪、HScode查询服务',
        '舱单申报优惠 AMS/ISF/ACI(EM)/AFR',
        '优惠价格享受FMC申请',
      ],
    },
  ],
  SPECIAL: [
    {
      title: '合作风险保障',
      children: [
        '享受专项合作风险保障金额5万美金',
        '专业团队协助纠纷处理',
        '跨联盟合作担保享受2.5万美金',
      ],
    },
    {
      title: '商机链接',
      children: [
        '专项货物有针对性询盘匹配和潜在生意撮合',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '专属会员身份标识',
        '专属客成经理一对一协助推荐潜在合作伙伴和生意',
        '上万家来自168个国家靠谱会员资源可供选择',
        '询盘平台无限发盘/应盘',
      ],
    },
    {
      title: '营销推广',
      children: [
        '专项货物成功案例在线推广',
        '向3万+粉丝、1万+付费会员持续推送，有效提升企业品牌知名度',
        '主站平台专属模块展示货物操作案例',
        '邮件推广',
        '社交媒体推广',
      ],
    },
    {
      title: '经营提效',
      children: [
        '在线使用全链路追踪，船期和HS Code查询功能，享受舱单申报和FMC申请优惠',
        '主站平台IM即时沟通在线联系',
        '线上支付工具使用JCPAY和TCS',
        '无上限船期、全链路跟踪、HScode查询服务',
        '舱单申报优惠 AMS/ISF/ACI(EM)/AFR',
        '优惠价格享受FMC申请',
      ],
    },
  ],
  JCV: [
    {
      title: '全球货代资源丰富',
      children: ['公司库专属JCV会员标识展示'],
    },
    {
      title: '商机链接',
      children: [
        '询盘+专属客成一对一支持',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '上万家来自168个国家靠谱会员资源可供选择',
        '询盘平台无限发盘/应盘',
        '专属客成经理一对一协助推荐潜在合作伙伴和生意',
      ],
    },
    {
      title: '营销推广',
      children: [
        '每月一次独家邮件推广',
        '询盘系统月均推送商机1万+, 发盘最快3分钟链接1万+优质货代',
        '社交媒体推广',
        '主站高端访谈展示',
        '定制化宣传手册每届会议发放',
      ],
    },
    {
      title: '经营提效',
      children: [
        '在线即时沟通全球货代会员',
        '主站平台IM即时沟通在线联系',
        '线上支付工具使用JCPAY和TCS',
        '会员间合作优惠特权',
      ],
    },
  ],
}

const ABOUT_TITLE_CN = '产品介绍'
const VIEW_MORE_CN = '查看更多'
export const JOIN_US_CN = '即刻链接全球货代'

export const membership_cn = {
  agent: {
    title: '系统推荐代理',
    desc: '3分钟推荐3个匹配货代给您（匹配方也可查看您联系方式），快速和更多货代建立联系！',
  },
  getContacts: '获取联系方式',
  dialog: {
    name: '姓名',
    country: '国家/区域',
    company: '公司英文名称',
    companyChinese: '公司中文名称',
    eMail: '邮箱',
    tel: '手机号',
    validatorName: '请填写您的姓名全称',
    validatorName1: '姓名全称不能超过128个字符',
    validatorCountry: '请填写您所属国家/地区',
    validatorCompany: '请填写您的公司英文名称',
    validatorCompany1: '公司英文名称为2-200个字符',
    validatorCompany2: '公司英文名称不能包括中文',
    validatorCompanyChinese: '请填写您的公司中文名称',
    validatorCompanyChinese1: '公司中文名称为2-200个字符',
    validatorCompanyEMail: '请填写您的企业邮箱',
    validatorCompanyEMail1: '邮箱不能超过90个字符',
    validatorCompanyEMail2: '当前不支持qq邮箱，请更换其他邮箱',
    validatorCompanyTel: '请填写您的手机号',
    validatorCompanyTel1: '手机号不能超过15个字符',
    ok: '好',
    success: '提交成功',
    verifyTitle: '请完成安全验证',
    verifyMessage: '向右滑动完成验证',
  },
  common: {
    memberList: '会员列表',
    benefits: '会员权益',
    joinUs: '加入会员',
    moreDetail: '更多详情',
    applyFor: JOIN_US_CN,
    welcome: '欢迎加入',
    viewMore: VIEW_MORE_CN,
    about: '关于',
    case: '案例',
    knowledge: '行业知识',
    all: '所有',
    contact: '联系方式',
    view: '查看',
    companyProfile: '公司简介',
    otherCase: '其它案例',
    recommend: '推荐',
    otherKnowledge: '其它行业知识',
    noData: '对不起，暂无数据',
    city: '城市',
    expires: '有效期（止）',

    generalMemberships: '普货联盟',
    specialtyMemberships: '专项联盟',
    supplierMemberships: '供应商联盟',
    premiumMember: '优质会员',

    welcome_title: '欢迎加入 ',
    why_title: ABOUT_TITLE_CN,
  },
  index: {
    title: 'JCtrans会员制产品介绍',
    description:
      'JCtrans Membership汇聚了全球优质的货代及上下游企业，为会员提供商机撮合、线上交易、合作风险保障、营销推广等相关服务，打造安全合作和诚信交易的信誉圈层，帮助会员企业持续盈利',
    why: ABOUT_TITLE_CN,
    overview: '了解更多会员权益',
    tagList: ['汇聚全球优质货代企业', '打造安全信誉圈层', '帮助企业持续盈利'],
  },
  overview: {
    title: '会员权益对比',
    basic_benefits: '基础权益',
    member_benefits: '会员权益',
    free: '非会员',
    member: '会员',
    introduction: 'JCtrans会员制产品介绍',
    join: JOIN_US_CN,
    overviewList: OVERVIEW_LIST.map((item) => item.cn),
    new: '新',
  },
  JCE: {
    title: 'JCtrans Elite',
    description: 'JCtrans严选，高端会员圈层，最高会员权益享受和合作风险保障。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '汇集了全球知名的货代企业，凭借着严格的审核标准，打造出了行业内资历深、规模大、具有超群实力和影响力的合作圈层。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCE,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JCE,
    },
    tagList: [
      '汇集了全球知名的货代企业',
      '严格的审核标准',
      '打造出了行业内资历深、规模大 、具有超群实力和影响力的合作圈层',
    ],
  },
  JCP: {
    title: 'JCtrans Premium',
    description:
      '体量最大的会员群体，全球认证货代企业超万家，多种渠道提供潜在合作机会。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '准入审核和合作保障打造安全合作的信誉圈层；通过平台询盘系统和线下全球会议为您带来更多合作商机；客户成功经理一对一服务；还有多种营销推广服务、快捷支付和免费工具。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCP,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JCP,
    },
    members: {
      more1: '5年以上',
      more2: 'JC Premium会员超过',
      more3: '5年以上JC Premium会员',
      more4: '超过2809家',
      experience: '会员年限',
      years: '年限',
      tag: '业务优势',
      memberYears: '会员年限',
    },
    tagList: [
      '会员家数众多的核心产品',
      '为每家付费会员提供每年10万USD的合作风险保障',
      '一对一定制化服务',
    ],
  },
  JCR: {
    title: 'JCtrans Rising',
    description: '通过审核认证，为新生货代企业提供资源支持，合作撮合服务。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '为新兴货代企业提供更多的发展机会和资源支持，提升企业曝光度和知名度，迅速融入会员圈层，助其完善全球代理网络，在行业中脱颖而出。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCR,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JCR,
      newMember: '新会员展示',
    },
    tagList: [
      '为新兴货代企业提供更多的发展机会和资源支持，提升企业曝光度和知名度',
      '助其完善全球代理网络，在行业中脱颖而出',
    ],
  },
  JCPR: {
    title: 'JCtrans Projects',
    description:
      '为专项业务领域提供发展支持，会员间进行业务撮合将更加有针对性，保障合作的专业与安全。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '汇集了项目货领域具备丰富经验、资质完善、专业性极强的企业。提高会员间针对项目货业务的合作效率，减少合作风险。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCPR,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JC_SPECIAL,
    },
    tab: '关于 JC Projects',
    tagList: [
      '汇集了项目货领域具备丰富经验的、资质完善的专业企业',
      '会员间可以更加便捷、高效地进行物流项目合作',
      ' 提高效率和专业性，减少合作风险',
    ],
  },
  JCDG: {
    title: 'JCtrans Dangerous Goods',
    description:
      '专项业务发展支持，更有针对性进行会员圈层内合作撮合，低风险环境保障。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '汇集世界各地拥有运输危险品资质和经验的货代企业，经过严格审核，确保会员能够提供更加专业、安全、高效的危险品物流服务。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCDG,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JC_SPECIAL,
    },
    tab: '关于 JC Dangerous Goods',
    tagList: [
      '汇集世界各地拥有运输危险品资质和经验的货代企业',
      '经过严格审核，确保会员能够提供更加专业、安全、高效的危险品物流服务',
    ],
  },
  SPECIAL: {
    description:
      '专项业务发展支持，更有针对性进行会员圈层内合作撮合，低风险环境保障。',
    about: {
      benefitsList: BASE_BENEFITS_LIST_CN.SPECIAL,
    },
  },
  JCEC: {
    title: 'JCtrans eCommerce',
    description:
      '专项业务发展支持，更有针对性进行会员圈层内合作撮合，低风险环境保障。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '提供一站式专业的电商物流解决方案和FBA货物运输服务，成员们在存储、分拣、包装、装配，派送等各个环节具有丰富经验。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCEC,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JC_SPECIAL,
    },
    tab: '关于 JC eCommerce',
    tagList: [
      '提供一站式专业的电商物流解决方案和FBA货物运输服务',
      '成员们在存储、分拣、包装、装配，派送等各个环节具有丰富经验',
    ],
  },
  JCRA: {
    title: 'JCtrans Railway',
    description:
      '专项业务发展支持，更有针对性进行会员圈层内合作撮合，低风险环境保障。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '提供全球范围内的铁路运输服务，涵盖中欧班列等主流铁路运输线路，根据客户需求和货物特性，制定最优的铁路运输方案。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCRA,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JC_SPECIAL,
    },
    tab: '关于 JC Railway',
    tagList: [
      '提供全球范围内的铁路运输服务',
      '涵盖中欧班列等主流铁路运输线路',
      '根据客户需求和货物特性，制定最优的铁路运输方案',
    ],
  },
  JCV: {
    title: 'JCtrans Vendor',
    description: '更多潜在合作机遇和合作伙伴资源，专属宣传模式。',
    about: {
      title: ABOUT_TITLE_CN,
      description:
        '汇集了提供物流运输、物流仓储、IT、咨询和金融保险的优质供应商，为货运代理企业提供全方位定制化服务及优质解决方案。',
      benefitsList: BASE_BENEFITS_LIST_CN.JCV,
      benefitsListNew: BASE_BENEFITS_LIST_CN_NEW.JCV,
    },
    noData: '对不起，暂无数据',
    service: {
      it: {
        name: 'IT服务供应商',
        desc: 'IT服务供应商将帮助货代企业实现信息化与数字化转型，优化传统企业结构，降低IT系统运维成本。实现企业IT业务标准化，提高工作效率，降低企业成本。',
      },
      warehousing: {
        name: '仓储供应商',
        desc: '提供与仓储相关的装拆箱，修洗箱，分拨配送服务以及集装箱与设备的租赁/买卖等服务',
      },
      transportation: {
        name: '运输供应商',
        desc: '能够提供海运、空运、铁路，公路等多种运输解决方案',
      },
      consulting: {
        name: '咨询服务供应商',
        desc: '咨询服务供应商依托信息和专业知识优势，运用先进的分析方法，为货代企业解决各种专业领域的复杂问题提供定制化解决方案。此外还将提供法务、培训、招聘和海外公司注册、资质办理等专业咨询服务',
      },
      finance: {
        name: '金融保障服务供应商',
        desc: '金融服务供应商能够为货代企业解决贸易流程中不同阶段的贷款融资等问题，通过提供多样的保险和供应链金融产品满足不同企业的金融需求，确保企业资金运转顺畅并降低财务风险',
      },
    },
    discount: {
      desc: '折扣优惠',
      title: 'JC Vendor优惠信息',
      viewMore: '查看更多优惠',
      sign: '请先进行登录',
    },
  },
}

export const membership_en = {
  agent: {
    title: 'System Recommended Agent',
    desc: 'Quickly recommend 3 freight forwarders(they can also contact you), quickly establish more connections!',
  },
  getContacts: 'Get Contacts',
  dialog: {
    name: 'Your Name',
    country: 'Country/Region',
    company: 'Company Name',
    companyChinese: 'Comp Name In Chinese',
    eMail: 'E-mail',
    tel: 'Tel',
    validatorName: 'Please fill in your full name',
    validatorName1: 'Your name cannot exceed 128 characters',
    validatorCountry: 'Please fill in your Country or Region',
    validatorCompany: 'Please fill in your company name',
    validatorCompany1: 'Company name must be at 2-200 characters',
    validatorCompany2: 'Do not include Chinese characters in company name',
    validatorCompanyChinese: 'Please fill in your company name in Chinese',
    validatorCompanyChinese1:
      'Company name in Chinese must be at 2-200 characters',
    validatorCompanyEMail: 'Please fill in your corporate e-mail',
    validatorCompanyEMail1: 'Email cannot exceed 90 characters',
    validatorCompanyEMail2:
      'QQ mailbox is not available, please change to another mailbox.',
    validatorCompanyTel: 'Please fill in your tel',
    validatorCompanyTel1: 'Tel cannot exceed 15 characters',
    ok: 'ok',
    success: 'Submit successfully!',
    verifyTitle: 'Please finish the security verification',
    verifyMessage: 'Swipe right to complete the picture puzzle',
  },
  common: {
    memberList: 'Member List',
    benefits: 'Member Benefits',
    joinUs: 'Become a Member',
    moreDetail: 'More Details',
    applyFor: JOIN_US_CN, // 此处不使用英文翻译
    welcome: 'Welcome to',
    viewMore: 'View More',
    about: 'About',
    case: 'Case',
    knowledge: 'Knowledge',
    all: 'All',
    contact: 'Contact',
    view: 'View',
    companyProfile: 'Company Profile',
    otherCase: 'Other Case',
    recommend: 'Recommend',
    otherKnowledge: 'Other Knowledges',
    noData: 'Sorry, no data available',
    city: 'City',
    expires: 'Expires',

    generalMemberships: 'General Membership',
    specialtyMemberships: 'Specialty Membership',
    supplierMemberships: 'Supplier Membership',
    premiumMember: 'Our Members',

    welcome_title: 'Welcome to ',
    why_title: 'Why ',
  },
  index: {
    title: 'Complete Membership Product Introduction',
    description:
      'JCtrans Membership brings together high-quality freight forwarding and upstream/downstream enterprises from around the world, providing members with services such as business matchmaking, online trading, cooperation risk protection, and marketing promotion. We aim to create a reputable circle of safe cooperation and honest transactions, helping member enterprises achieve sustained profitability.',
    why: 'Why JC Membership',
    overview: 'Benefits Overview',
    tagList: [
      'Brings Together High-Quality Freight Forwarding',
      'Create A Reputable Circle',
      'Achieve Sustained Profitability',
    ],
  },
  overview: {
    title: 'Benefits Overview',
    basic_benefits: 'Basic Benefits',
    member_benefits: 'Member Benefits',
    free: 'Free',
    member: 'Member',
    introduction: 'Complete Membership Product Introduction',
    join: 'Apply for JCtrans membership',
    overviewList: OVERVIEW_LIST.map((item) => item.en),
    new: 'New',
  },
  JCE: {
    title: 'JCtrans Elite Membership',
    description:
      'JCtrans carefully selects members for its elite circle, offering the highest member benefits and cooperation risk protection.',
    about: {
      title: 'Why JC Elite?',
      description:
        'Gathering renowned freight forwarding companies globally, JC Elite establishes a cooperation circle with outstanding qualifications, large scale, exceptional strength, and influence, all achieved through stringent auditing standards within the industry.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCE,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JCE,
    },
    tagList: [
      'An alliance of senior freight forwarding enterprises',
      'Strict selection',
      'A cooperation circle with outstanding qualifications and influence',
    ],
  },
  JCP: {
    title: 'JCtrans Premium Membership',
    description:
      'The largest member group, with over ten thousand globally certified freight forwarding companies, offering potential cooperation opportunities through multiple channels.Cooperation Risk Protection.',
    about: {
      title: 'Why JC Premium?',
      description: `Rigorous vetting & Collaboration Safeguards - a trusted circle for secure partnerships. More global business opportunities - access premium leads via platform inquiries and global conferences. 1 on 1 customer success manager - tailored support for your business goals. Multiple solutions - marketing services, instant payment, and free tools included.`,
      benefitsList: BASE_BENEFITS_LIST_EN.JCP,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JCP,
    },
    tagList: [
      'Our core product with numerous members',
      '$100,000 USD in cooperation risk protection annually',
      'Personalized one-on-one services',
    ],
    members: {
      more1: '5-Years',
      more2: 'Premium members amount',
      more3: '5-Years Premium Members',
      more4: 'Amount Exceeded 2809',
      experience: 'Years of experience',
      years: 'Years',
      tag: 'Tag/S',
      memberYears: 'Membership yrs',
    },
  },
  JCR: {
    title: 'JCtrans Rising Membership',
    description:
      'Provides resource support and cooperation matchmaking services for newly established freight forwarding companies, through audit and certification.',
    about: {
      title: 'Why JC Rising?',
      description:
        'Providing emerging freight forwarding companies with more development opportunities and resource support, JC Rising enhances exposure and reputation, swiftly integrating them into the member circle, assisting in establishing a comprehensive global agency platform and standing out in the industry.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCR,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JCR,
      newMember: 'New enrolled Rising members',
    },
    tagList: [
      'Providing emerging freight forwarding companies with more development opportunities and resource support',
      'Assisting in establishing a comprehensive global agency platform',
    ],
  },
  JCPR: {
    title: 'JCtrans Projects Membership',
    description:
      'We provide development support for specialized business sectors, ensuring more targeted business matchmaking among members to guarantee professionalism and safety in cooperation.',
    about: {
      title: 'Why JC Projects?',
      description:
        'We gather enterprises in the project cargo field that are highly experienced, fully certified, and exceptionally professional. This enhances the efficiency of member-to-member cooperation on project cargo business and reduces collaboration risks.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCPR,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL,
    },
    tab: 'About JC Projects',
    tagList: [
      'Gathering professional companies with rich experience and perfect qualifications',
      'Efficient logistics project cooperation among members',
      'Increasing efficiency, professionalism, and reducing cooperation risks',
    ],
  },
  JCDG: {
    title: 'JCtrans Dangerous Goods Membership',
    description:
      'Targeted support for specialized business development, facilitating member collaboration within the circle more effectively, with a low-risk environment guarantee.',
    about: {
      title: 'Why JC Dangerous Goods?',
      description:
        'Bringing together freight forwarding companies worldwide with qualifications and experience in transporting dangerous goods, JC Dangerous Goods undergoes rigorous auditing to ensure members can provide more professional, safe, and efficient dangerous goods logistics services.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCDG,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL,
    },
    tab: 'About JC Dangerous Goods',
    tagList: [
      'Bringing together freight forwarding companies worldwide with qualifications and experience in transporting dangerous goods',
      'Undergoes rigorous auditing to ensure members can provide more professional, safe, and efficient dangerous goods logistics services',
    ],
  },

  SPECIAL: {
    description:
      'Targeted support for specialized business development, facilitating member collaboration within the circle more effectively, with a low-risk environment guarantee.',
    about: {
      benefitsList: BASE_BENEFITS_LIST_EN.SPECIAL,
    },
  },

  JCEC: {
    title: 'JCtrans eCommerce Membership',
    description:
      'Targeted support for specialized business development, facilitating member collaboration within the circle more effectively, with a low-risk environment guarantee.',
    about: {
      title: 'Why JC eCommerce?',
      description:
        'Offer a comprehensive and professional e-commerce logistics solution and FBA cargo transportation service. They have abundant experience in various aspects, including storage, sorting, packaging, assembly, and delivery.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCEC,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL,
    },
    tab: 'About JC eCommerce',
    tagList: [
      'Offer a comprehensive and professional e-commerce logistics solution and FBA cargo transportation service',
      'Members have abundant experience in various aspects, including storage, sorting, packaging, assembly, and delivery',
    ],
  },
  JCRA: {
    title: 'JCtrans Railway Membership',
    description:
      'Targeted support for specialized business development, facilitating member collaboration within the circle more effectively, with a low-risk environment guarantee.',
    about: {
      title: 'Why JC Railway?',
      description:
        'Provide railway transportation services worldwide, covering mainstream railway routes such as the China-Europe Express(CHINARAILWAYExpress) and others. They tailor the most optimal railway transportation solutions based on customer needs and cargo characteristics.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCRA,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL,
    },
    tab: 'About JC Railway',
    tagList: [
      'Provide railway transportation services worldwide',
      'Covering mainstream railway routes such as the China-Europe Express and others',
      'Tailor the most optimal railway transportation solutions',
    ],
  },
  JCV: {
    title: 'JCtrans Vendor Membership',
    description:
      'Access to more potential cooperation opportunities and partner resources, with an exclusive promotional model.',
    about: {
      title: 'Why JC Vendor?',
      description:
        'JC Vendor brings together premium suppliers offering logistics transportation, warehousing, IT, consulting, and financial insurance services, providing freight forwarding enterprises with comprehensive customized services and high-quality solutions.',
      benefitsList: BASE_BENEFITS_LIST_EN.JCV,
      benefitsListNew: BASE_BENEFITS_LIST_EN_NEW.JCV,
    },
    noData: 'Sorry, no Vendor available',
    service: {
      it: {
        name: 'IT Services',
        desc: 'IT services providers will help freight forwarding enterprises achieve informatization and digital transformation, optimize the traditional enterprise structure, and reduce the operation and maintenance cost of IT systems. Meanwhile, they can achieve the standardization of enterprise IT business, improve work efficiency and reduce corporate costs.',
      },
      warehousing: {
        name: 'Warehousing',
        desc: 'Provision of warehousing-related packing and unpacking, container repair and cleaning, distribution and dispatch services, and container and equipment rental/sale and purchase',
      },
      transportation: {
        name: 'Transportation',
        desc: 'JC Vendor members are able to provide a variety of transportation solutions such as sea, air, railway, and road freight.',
      },
      consulting: {
        name: 'Consulting Services',
        desc: 'Relying on the advantages of information and professional knowledge and using advanced analysis methods, the consulting services providers will provide personalized solutions for freight forwarding enterprises and solve complex problems in various professional fields. In addition, professional consulting services such as legal affairs, training, recruitment, overseas company registration and qualification handling will be provided.',
      },
      finance: {
        name: 'Finance Services',
        desc: 'Finance services providers can satisfy the needs of freight forwarding enterprises for loan financing at different stages of the trade process, and meet the financial needs of different enterprises by providing various insurance and supply chain financial products, so as to ensure the smooth operation of enterprise funds and reduce financial risks.',
      },
    },
    discount: {
      desc: 'Discount',
      title: 'JC Vendor Discount',
      viewMore: 'View more Vendor discount!',
      sign: 'Please Sign In First',
    },
  },
}
